import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon/Icon.js';
import { Root, Indicator } from '@radix-ui/react-checkbox';

const Checkbox = /*#__PURE__*/forwardRef(function Checkbox(props, ref) {
  const {
    checked,
    highlighted,
    indeterminate,
    invalid,
    label,
    onChange,
    ...otherProps
  } = props;
  const className = cn('bg-white h-5 w-5 border rounded text-sm flex-shrink-0 self-start mt-[0.1rem] focus:yt-focus', //hover:shadow-[0_0_0_1px_rgba(235,235,235,1)]
  props.className, {
    'border-grey-dark text-blue hover:text-blue-light focus:border-blue focus:hover:border-blue-light': !props.disabled && !invalid,
    'border-grey text-blue-light cursor-not-allowed': props.disabled,
    'bg-[rgba(255,255,0,0.2)] disabled:bg-[rgba(255,255,0,0.075)]': highlighted,
    'border-red text-red hover:text-red-light hover:border-red-light focus:border-red focus:hover:border-red-light': invalid && !props.disabled
  });
  let handleChange;

  if (onChange) {
    handleChange = checked => onChange(checked === 'indeterminate' ? false : checked);
  }

  const element = createElement(Root, Object.assign({}, otherProps, {
    "data-taco": "checkbox",
    checked: indeterminate ? 'indeterminate' : checked,
    className: className,
    onCheckedChange: handleChange,
    ref: ref
  }), createElement(Indicator, {
    className: "flex h-full w-full"
  }, createElement(Icon, {
    name: indeterminate ? 'line' : 'tick',
    className: "!h-full !w-full"
  })));

  if (label) {
    const labelClassName = cn('flex items-center cursor-pointer gap-2', {
      'cursor-not-allowed text-grey-dark': props.disabled
    }, props.className);
    return createElement("label", {
      className: labelClassName
    }, element, label);
  }

  return element;
});

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map
